// frontend/src/components/config/PanelTarifas.jsx
import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';
function getToken(){ return localStorage.getItem('calleb_token'); }
function authHeaders(){ const t=getToken(); return t?{Authorization:`Bearer ${t}`}:{}; }
function fmt(val){ return `$${parseFloat(val||0).toFixed(2)}`; }

// ── Modal cuota extraordinaria ────────────────────────────
function ModalExtraordinaria({ cuota, onClose, onGuardado }) {
  const esNueva = !cuota;
  const [form, setForm] = useState({
    descripcion: cuota?.descripcion||'',
    monto:       cuota?.monto||'',
    anio_fiscal: cuota?.anio_fiscal||new Date().getFullYear(),
    fecha_cargo: cuota?.fecha_cargo?.slice(0,10)||new Date().toISOString().slice(0,10),
  });
  const [guardando,setGuardando]=useState(false);
  const [error,setError]=useState(null);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const handleGuardar = async () => {
    if(!form.descripcion||!form.monto){setError('Faltan campos');return;}
    setGuardando(true);setError(null);
    try {
      let res;
      if(esNueva){
        res = await fetch(`${API}/casas/cuota-extraordinaria`,{
          method:'POST',headers:{'Content-Type':'application/json',...authHeaders()},
          body:JSON.stringify({...form,monto:parseFloat(form.monto),generadoPor:'ADMIN'}),
        });
      } else {
        res = await fetch(`${API}/cargos/${cuota.id}`,{
          method:'PUT',headers:{'Content-Type':'application/json',...authHeaders()},
          body:JSON.stringify({...form,monto:parseFloat(form.monto)}),
        });
      }
      const data=await res.json();
      if(!data.ok) throw new Error(data.mensaje);
      onGuardado();
    }catch(e){setError(e.message);}
    finally{setGuardando(false);}
  };

  const handleEliminar = async () => {
    if(!window.confirm('¿Eliminar esta cuota extraordinaria?')) return;
    setGuardando(true);
    try {
      const res=await fetch(`${API}/cargos/${cuota.id}`,{method:'DELETE',headers:authHeaders()});
      const data=await res.json();
      if(!data.ok) throw new Error(data.mensaje);
      onGuardado();
    }catch(e){setError(e.message);}
    finally{setGuardando(false);}
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',
        display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,
          padding:28,width:'100%',maxWidth:420,boxShadow:'0 20px 60px rgba(0,0,0,.25)'}}>
        <h3 style={{fontSize:16,fontWeight:700,color:'#1a3a5c',marginBottom:20}}>
          {esNueva?'⚡ Nueva Cuota Extraordinaria':'✏️ Editar Cuota Extraordinaria'}
        </h3>
        {error&&<div style={{padding:'10px',background:'#fef2f2',color:'#dc2626',
                             borderRadius:8,marginBottom:14,fontSize:13}}>⚠️ {error}</div>}
        <div style={{display:'grid',gap:12}}>
          <div>
            <label style={lbl}>Descripción*</label>
            <input type="text" value={form.descripcion}
                   onChange={e=>set('descripcion',e.target.value)} style={inp}
                   placeholder="ej. Reparación portones junio 2026"/>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div>
              <label style={lbl}>Monto (USD)*</label>
              <input type="number" step="0.01" value={form.monto}
                     onChange={e=>set('monto',e.target.value)} style={inp}/>
            </div>
            <div>
              <label style={lbl}>Año Fiscal</label>
              <input type="number" value={form.anio_fiscal}
                     onChange={e=>set('anio_fiscal',parseInt(e.target.value))} style={inp}/>
            </div>
          </div>
          {!esNueva && (
            <div>
              <label style={lbl}>Fecha</label>
              <input type="date" value={form.fecha_cargo}
                     onChange={e=>set('fecha_cargo',e.target.value)} style={inp}/>
            </div>
          )}
          {esNueva && (
            <div style={{background:'#fef9c3',borderRadius:8,padding:12,fontSize:12,color:'#92400e'}}>
              ⚡ Se aplicará a <strong>todas las casas activas</strong> simultáneamente.
            </div>
          )}
        </div>
        <div style={{display:'flex',gap:8,marginTop:20}}>
          {!esNueva&&(
            <button onClick={handleEliminar} disabled={guardando}
                    style={{...btn,background:'#fef2f2',color:'#dc2626',flex:1}}>
              🗑 Eliminar
            </button>
          )}
          <button onClick={onClose} style={{...btn,background:'#f3f4f6',color:'#374151',flex:1}}>
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={guardando}
                  style={{...btn,background:'#1a3a5c',color:'#fff',flex:2}}>
            {guardando?'Guardando…':'💾 Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PanelTarifas() {
  const anioActual = new Date().getFullYear();
  const [zonas,       setZonas]       = useState([]);
  const [historico,   setHistorico]   = useState([]);
  const [extraordinarias,setExtraordinarias]=useState([]);
  const [anio,        setAnio]        = useState(anioActual);
  const [loading,     setLoading]     = useState(false);
  const [guardando,   setGuardando]   = useState(false);
  const [msg,         setMsg]         = useState(null);
  const [tarifas,     setTarifas]     = useState({});
  const [modalExtra,  setModalExtra]  = useState(null);

  const anios = [anioActual, anioActual-1, anioActual-2];

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [zonasRes, histRes, extraRes] = await Promise.all([
        fetch(`${API}/zonas?anio=${anio}`,{headers:authHeaders()}).then(r=>r.json()),
        fetch(`${API}/zonas/tarifas-historico`,{headers:authHeaders()}).then(r=>r.json()),
        fetch(`${API}/cargos?tipo=CUOTA_EXTRA`,{headers:authHeaders()}).then(r=>r.json()),
      ]);
      if(zonasRes.ok){
        setZonas(zonasRes.zonas||[]);
        const t={};
        (zonasRes.zonas||[]).forEach(z=>{t[z.id]=z.tarifa_anual||'';});
        setTarifas(t);
      }
      if(histRes.ok) setHistorico(histRes.tarifas||[]);
      if(extraRes.ok) setExtraordinarias(extraRes.cargos||[]);
    }catch(e){setMsg({ok:false,texto:e.message});}
    finally{setLoading(false);}
  },[anio]);

  useEffect(()=>{cargar();},[cargar]);

  const handleGuardar = async () => {
    setGuardando(true); setMsg(null);
    try {
      const payload=Object.entries(tarifas)
        .filter(([,v])=>v!==''&&parseFloat(v)>=0)
        .map(([zona_id,monto])=>({zona_id:parseInt(zona_id),monto:parseFloat(monto),anio}));
      const res=await fetch(`${API}/zonas/tarifas`,{
        method:'POST',headers:{'Content-Type':'application/json',...authHeaders()},
        body:JSON.stringify({tarifas:payload}),
      });
      const data=await res.json();
      if(!data.ok) throw new Error(data.mensaje);
      setMsg({ok:true,texto:`Tarifas ${anio} guardadas correctamente.`});
      cargar();
    }catch(e){setMsg({ok:false,texto:e.message});}
    finally{setGuardando(false);}
  };

  const handleEliminarTarifa = async (zonaId, anioTarifa) => {
    if(!window.confirm(`¿Eliminar la tarifa ${anioTarifa} de esta zona?`)) return;
    try {
      const res=await fetch(`${API}/zonas/tarifas/${zonaId}/${anioTarifa}`,
        {method:'DELETE',headers:authHeaders()});
      const data=await res.json();
      if(!data.ok) throw new Error(data.mensaje);
      cargar();
    }catch(e){setMsg({ok:false,texto:e.message});}
  };

  return (
    <div style={{padding:24}}>
      <h2 style={{fontSize:20,fontWeight:700,color:'#1a3a5c',marginBottom:4}}>
        🗺️ Tarifas y Cuotas Extraordinarias
      </h2>
      <p style={{fontSize:12,color:'#6b7280',marginBottom:24}}>
        Gestiona las tarifas anuales por zona y las cuotas extraordinarias.
      </p>

      {/* ── Tarifas por zona ── */}
      <div style={{background:'#fff',borderRadius:12,padding:24,
                   boxShadow:'0 1px 4px rgba(0,0,0,.08)',marginBottom:20}}>
        <div style={{display:'flex',justifyContent:'space-between',
                     alignItems:'center',marginBottom:16}}>
          <h3 style={{fontSize:15,fontWeight:700,color:'#1a3a5c',margin:0}}>
            Tarifas Anuales por Zona
          </h3>
          <select value={anio} onChange={e=>setAnio(parseInt(e.target.value))} style={inp2}>
            {anios.map(a=><option key={a} value={a}>{a}</option>)}
          </select>
        </div>

        {msg&&(
          <div style={{padding:'10px 14px',borderRadius:8,marginBottom:16,
                       background:msg.ok?'#f0fdf4':'#fef2f2',
                       color:msg.ok?'#15803d':'#dc2626',fontSize:13}}>
            {msg.ok?'✅':'❌'} {msg.texto}
          </div>
        )}

        {loading?(
          <p style={{color:'#9ca3af',fontSize:13}}>Cargando…</p>
        ):(
          <>
            {zonas.map(z=>(
              <div key={z.id} style={{display:'flex',alignItems:'center',
                                      gap:12,marginBottom:12}}>
                <div style={{flex:1,fontWeight:600,fontSize:14,color:'#1a3a5c'}}>
                  {z.nombre}
                  <span style={{fontSize:11,color:'#9ca3af',marginLeft:6}}>
                    ({z.total_casas} casas)
                  </span>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <span style={{fontSize:13,color:'#6b7280'}}>$</span>
                  <input type="number" step="0.01" min="0"
                         value={tarifas[z.id]||''}
                         onChange={e=>setTarifas(t=>({...t,[z.id]:e.target.value}))}
                         placeholder="0.00"
                         style={{...inp2,width:120,textAlign:'right'}}/>
                  <span style={{fontSize:11,color:'#9ca3af'}}>USD/año</span>
                </div>
              </div>
            ))}
            <button onClick={handleGuardar} disabled={guardando}
                    style={{...btn,background:'#1a3a5c',color:'#fff',
                             padding:'10px 24px',width:'100%',marginTop:8,
                             opacity:guardando?.6:1}}>
              {guardando?'Guardando…':`💾 Guardar Tarifas ${anio}`}
            </button>
          </>
        )}
      </div>

      {/* ── Historial de tarifas ── */}
      <div style={{background:'#fff',borderRadius:12,padding:24,
                   boxShadow:'0 1px 4px rgba(0,0,0,.08)',marginBottom:20}}>
        <h3 style={{fontSize:15,fontWeight:700,color:'#1a3a5c',marginBottom:16}}>
          📅 Historial de Tarifas
        </h3>
        {historico.length===0?(
          <p style={{color:'#9ca3af',fontSize:13}}>No hay historial registrado.</p>
        ):(
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead>
              <tr style={{background:'#f8fafc'}}>
                {['Zona','Año','Monto','Moneda',''].map(h=>(
                  <th key={h} style={{padding:'8px 12px',textAlign:'left',fontSize:11,
                                      fontWeight:600,color:'#6b7280',
                                      borderBottom:'2px solid #e5e7eb'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {historico.map((t,i)=>(
                <tr key={i} style={{borderBottom:'1px solid #f3f4f6'}}>
                  <td style={td}>{t.zona}</td>
                  <td style={td}><strong>{t.anio}</strong></td>
                  <td style={{...td,fontWeight:700,color:'#1a3a5c'}}>{fmt(t.monto_anual)}</td>
                  <td style={{...td,color:'#6b7280'}}>{t.moneda}</td>
                  <td style={td}>
                    <button onClick={()=>handleEliminarTarifa(t.zona_id,t.anio)}
                            style={{...btn,background:'#fef2f2',color:'#dc2626',
                                    padding:'3px 8px',fontSize:11}}>
                      🗑
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Cuotas Extraordinarias ── */}
      <div style={{background:'#fff',borderRadius:12,padding:24,
                   boxShadow:'0 1px 4px rgba(0,0,0,.08)'}}>
        <div style={{display:'flex',justifyContent:'space-between',
                     alignItems:'center',marginBottom:16}}>
          <h3 style={{fontSize:15,fontWeight:700,color:'#1a3a5c',margin:0}}>
            ⚡ Cuotas Extraordinarias
          </h3>
          <button onClick={()=>setModalExtra('nueva')}
                  style={{...btn,background:'#b45309',color:'#fff',padding:'7px 14px'}}>
            + Nueva Cuota
          </button>
        </div>
        {extraordinarias.length===0?(
          <p style={{color:'#9ca3af',fontSize:13}}>No hay cuotas extraordinarias registradas.</p>
        ):(
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead>
              <tr style={{background:'#f8fafc'}}>
                {['Año','Descripción','Monto por Casa','Total Casas',''].map(h=>(
                  <th key={h} style={{padding:'8px 12px',textAlign:'left',fontSize:11,
                                      fontWeight:600,color:'#6b7280',
                                      borderBottom:'2px solid #e5e7eb'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {extraordinarias.map(c=>(
                <tr key={c.id} style={{borderBottom:'1px solid #f3f4f6'}}>
                  <td style={td}>{c.anio_fiscal}</td>
                  <td style={td}>{c.descripcion}</td>
                  <td style={{...td,fontWeight:700,color:'#b45309'}}>{fmt(c.monto)}</td>
                  <td style={{...td,color:'#6b7280'}}>{c.total_casas} casas</td>
                  <td style={td}>
                    <button onClick={()=>setModalExtra(c)}
                            style={{...btn,background:'#f3f4f6',color:'#374151',
                                    padding:'4px 10px',fontSize:11}}>
                      ✏️ Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modalExtra&&(
        <ModalExtraordinaria
          cuota={modalExtra==='nueva'?null:modalExtra}
          onClose={()=>setModalExtra(null)}
          onGuardado={()=>{setModalExtra(null);cargar();}}
        />
      )}
    </div>
  );
}

const inp  = {padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',
              fontSize:13,background:'#fff',color:'#374151',width:'100%',boxSizing:'border-box'};
const inp2 = {padding:'7px 10px',borderRadius:8,border:'1px solid #d1d5db',
              fontSize:13,background:'#fff',color:'#374151'};
const lbl  = {display:'block',fontSize:11,fontWeight:600,color:'#374151',marginBottom:4};
const btn  = {border:'none',borderRadius:8,padding:'8px 14px',fontSize:12,cursor:'pointer',fontWeight:600};
const td   = {padding:'10px 12px',verticalAlign:'middle',fontSize:13};
